<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <PmNoRealDataQueryLeftTree ref="PmNoRealDataQueryLeftTree" @transferNodeInfoOfResourceTreeSelected="transferNodeInfoOfResourceTreeSelected"></PmNoRealDataQueryLeftTree>
    </template>
    <template v-slot:right_view>
      <PmNoRealDataQueryRightList ref="PmNoRealDataQueryRightList" :selectNeId="selectNeId" :selectNeType="selectNeType"></PmNoRealDataQueryRightList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../layouts/BasicLayout';
  import PmNoRealDataQueryLeftTree from '../../../components/pmConfig/pproject/PmDataQueryForP/Left/PmNoRealDataQueryLeftTree';
  import PmNoRealDataQueryRightList from '../../../components/pmConfig/pproject/PmDataQueryForP/Right/PmNoRealDataQueryRightList';

  export default {
    name: 'PmNoRealDataQuery',
    components: {
      BasicLayout,
      PmNoRealDataQueryLeftTree,
      PmNoRealDataQueryRightList
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Pm.noRealDataQuery')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.noRealDataQuery')}`
        },
        selectNeId: 1,
        selectNeType: 101,
      }
    },
    methods: {
      transferNodeInfoOfResourceTreeSelected(node){
        if(node.nodeData.parentID != null && node.nodeData.parentID != 'root'){
          this.selectNeId = node.nodeData.id;
          this.selectNeType = node.nodeData.parentID.split('_')[1];
        }
      }
    }
  };
</script>

<style>

</style>
